import { Key } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  Typography,
} from '@mui/material';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';
import { useEmployeeProfile } from '~/data/employeeProfile';
import { AccountManagementMenu_OnUpdateLegacy } from '~/library/AccountManagementMenu/component';

import { useChangeUserName } from './useChangeUserName';

type Props = AccountManagementMenu_OnUpdateLegacy & {
  open: boolean;
  onClose: () => void;
};

export const ChangeUserName = ({ open, onClose, onUpdateLegacy }: Props) => {
  const { t } = useTranslation();

  const { profile } = useEmployeeProfile();
  const getTitleWithEmployeeName = useCallback(
    (title) =>
      !!profile ? `${title} - ${profile.firstName} ${profile.lastName}` : title,
    [profile],
  );

  const onSubmitSuccess = useCallback(() => {
    if (!!onUpdateLegacy) {
      onUpdateLegacy(['changeUserName']);
    }
    onClose();
  }, [onUpdateLegacy, onClose]);

  const { onSubmit, userName, handleChange, canSubmit } = useChangeUserName({
    onSubmitSuccess,
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <SolaForceDialogTitle onClose={onClose} icon={<Key />}>
        {getTitleWithEmployeeName(t('laChangeUsername'))}
      </SolaForceDialogTitle>
      <DialogContent dividers={true}>
        <Box>
          <TextField
            name={'laLoginUsername'}
            label={t('laLoginUsername')}
            value={userName}
            onChange={handleChange}
            fullWidth={true}
          />
        </Box>
        <Typography variant={'caption'}>{t('laUsernameHint')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={'secondary'}>
          {t('cancel')}
        </Button>
        <Button onClick={onSubmit} disabled={!canSubmit}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
